const Char = require("is-chinese-character");
const JapChar = require("japanese-characters");

const letterWidths: {[letter: string]: number} = {
    "0": 10.94,
    "1": 10.94,
    "2": 10.94,
    "3": 10.94,
    "4": 10.94,
    "5": 10.94,
    "6": 10.94,
    "7": 10.94,
    "8": 10.94,
    "9": 10.94,
    q: 12.2,
    w: 15.8,
    e: 10.91,
    r: 7.64,
    t: 7.44,
    z: 9.36,
    u: 11.97,
    i: 5.41,
    o: 11.94,
    p: 12.2,
    ő: 11.94,
    ú: 11.97,
    ó: 11.94,
    ü: 11.97,
    ö: 11.94,
    Q: 14.61,
    W: 17.3,
    E: 11.59,
    R: 12.52,
    T: 11.8,
    Z: 11.86,
    U: 14.19,
    I: 5.78,
    O: 14.61,
    P: 12.45,
    Ő: 14.61,
    Ú: 14.19,
    Ó: 14.61,
    Ü: 14.19,
    Ö: 14.61,
    a: 11.09,
    s: 9.22,
    d: 12.2,
    f: 6.44,
    g: 11.09,
    h: 11.97,
    j: 5.44,
    k: 10.89,
    l: 5.61,
    é: 10.91,
    á: 11.09,
    ű: 11.97,
    í: 5.41,
    y: 10.28,
    x: 9.81,
    c: 10.03,
    v: 10.28,
    b: 12.17,
    n: 12.03,
    m: 18.23,
    A: 11.97,
    S: 11.75,
    D: 13.53,
    F: 10.88,
    G: 13.58,
    H: 14.34,
    J: 10.56,
    K: 12.73,
    L: 10.7,
    É: 11.59,
    Á: 11.97,
    Ű: 14.19,
    Í: 5.78,
    Y: 10.47,
    X: 11.28,
    C: 12.56,
    V: 11.33,
    B: 12.94,
    N: 14.23,
    M: 15.98,
    ",": 5.47,
    "?": 9.36,
    ":": 5.47,
    "-": 6.84,
    ".": 5.47,
};

export const getLyricWidth = (word: string) => {
    if (!word) return 0;
    return word.split("").reduce((total, l) => {
        if (JapChar.presentIn(l)) return 22.5 + total;
        if (Char.isChineseCharacter(l)) return 23 + total;
        return (letterWidths[l] || 12) + total;
    }, 0);
};